import { handleSessionExpired } from '@/api/axiosInterceptors';
import type { PiniaPluginContext } from 'pinia';

/**
 * Pinia plugin: any store action that fails with a 401 triggers a global
 * session-expired cleanup (destroy socket, logout, redirect to /login).
 *
 * Why at the Pinia layer: @beeboard/common's generated OpenAPI client is
 * bundled separately by Vite and ends up with its own axios instance, so our
 * global axios response interceptor doesn't see its ApiErrors. Virtually every
 * authenticated API call in the app goes through a Pinia store action though,
 * so the action-error hook is a reliable catch-net regardless of which axios
 * throws. See work item #5436.
 */
export const sessionGuardPlugin = (ctx: PiniaPluginContext) => {
  ctx.store.$onAction(({ onError }) => {
    onError((error) => {
      const status =
        (error as { status?: number })?.status ??
        (error as { response?: { status?: number } })?.response?.status;
      if (status === 401) {
        handleSessionExpired();
      }
    });
  });
};
